import { PartnerOnboardingEntityRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useResendOnboardingEmail() {
  const [resendingOnboardingEmail, setResendingOnboardingEmail] = useState(false);

  async function resendOnboardingEmail(params: PartnerOnboardingEntityRequest) {
    try {
      setResendingOnboardingEmail(true);
      const res = await api.resendPartnerOnboardingEmail(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setResendingOnboardingEmail(false);
    }
  }

  return { resendingOnboardingEmail, resendOnboardingEmail };
}
